/**
 * Splits ledgerNameList entries containing multiple comma-separated GST numbers
 * into separate row entries, one for each individual GST number.
 *
 * Example:
 * Input:
 * [{
 *   id: 1052,
 *   entityPrimaryId: 27,
 *   gstNo: "09PPPCP4424S1ZA, 16PPPCP4424S1Z1, 21PPPCP4424S2ZQ",
 *   companyName: "Across Assist Limited",
 *   ledgerName: "TEMP_LEDGER, SECOND)_LEDGER"
 * }]
 *
 * Output: 3 separate objects, each having an individual `gstNo`.
 *
 * @param {Array} list - raw ledgerNameList array
 * @returns {Array} normalized list with separated GST rows
 */
export const normalizeLedgerNameList = (list) => {
  if (!Array.isArray(list)) return [];
  const result = [];

  list.forEach((item) => {
    if (!item) return;

    // Check gstNo or gstNumbers for comma-separated values
    const rawGst =
      (typeof item.gstNo === "string" ? item.gstNo : "") ||
      (typeof item.gstNumbers === "string" ? item.gstNumbers : "") ||
      "";

    if (rawGst && rawGst.includes(",")) {
      const splitGsts = rawGst
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

      if (splitGsts.length > 0) {
        splitGsts.forEach((gst) => {
          result.push({
            ...item,
            gstNo: gst,
          });
        });
        return;
      }
    }

    result.push({
      ...item,
      gstNo: typeof item.gstNo === "string" ? item.gstNo.trim() : item.gstNo,
    });
  });

  return result;
};
